"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeEnum = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./DynamicBulletPagination.style"));

var PaginationArrow_1 = tslib_1.__importDefault(require("./PaginationArrow"));

var useDynamicBullet_1 = tslib_1.__importDefault(require("./useDynamicBullet"));

var SizeEnum;

(function (SizeEnum) {
  SizeEnum["LARGE"] = "LARGE";
  SizeEnum["MEDIUM"] = "MEDIUM";
  SizeEnum["SMALL"] = "SMALL";
  SizeEnum["NONE"] = "NONE";
})(SizeEnum = exports.SizeEnum || (exports.SizeEnum = {}));
/**
 * instagram dots style
 *
 * <= 5개
 *  - 동일한 크기로 그대로 노출
 * > 5개
 *  - viewport: 전체 크기
 *  - center:····· (정상 크기로 보이는 5개)
 */


function DynamicBulletPagination(_ref) {
  var activeIndex = _ref.activeIndex,
      slideLength = _ref.slideLength,
      dispatchActiveIndex = _ref.dispatchActiveIndex;

  var _useDynamicBullet_1$d = useDynamicBullet_1.default({
    activeIndex: activeIndex,
    slideLength: slideLength
  }),
      viewportWidth = _useDynamicBullet_1$d.viewportWidth,
      bulletCounts = _useDynamicBullet_1$d.bulletCounts,
      circlePositionX = _useDynamicBullet_1$d.circlePositionX,
      centerPosition = _useDynamicBullet_1$d.centerPosition;

  var getSize = react_1.useCallback(function (posX, index) {
    var absDiff = Math.abs(posX - index);

    if (absDiff === 3) {
      return SizeEnum.MEDIUM;
    }

    if (absDiff === 4) {
      return SizeEnum.SMALL;
    }

    if (absDiff > 4) {
      return SizeEnum.NONE;
    }

    return SizeEnum.LARGE;
  }, []);
  var leftArrowClick = react_1.useCallback(function (event) {
    event.stopPropagation();
    dispatchActiveIndex(activeIndex - 1);
  }, [activeIndex]);
  var rightArrowClick = react_1.useCallback(function (event) {
    event.stopPropagation();
    dispatchActiveIndex(activeIndex + 1);
  }, [activeIndex]);
  var isRemainLeft = activeIndex > 0;
  var isRemainRight = activeIndex < slideLength - 1;
  return jsx_runtime_1.jsxs(react_1.Fragment, {
    children: [jsx_runtime_1.jsx("ul", Object.assign({
      css: styles.container(viewportWidth, bulletCounts)
    }, {
      children: Array(slideLength).fill(0).map(function (_v, index) {
        return jsx_runtime_1.jsx("li", Object.assign({
          css: [styles.bullet(circlePositionX, getSize(centerPosition, index)), index === activeIndex && styles.active]
        }, {
          children: jsx_runtime_1.jsx("span", {}, void 0)
        }), index);
      })
    }), void 0), jsx_runtime_1.jsx(PaginationArrow_1.default, {
      isRemainLeft: isRemainLeft,
      isRemainRight: isRemainRight,
      leftArrowClick: leftArrowClick,
      rightArrowClick: rightArrowClick
    }, void 0)]
  }, void 0);
}

exports.default = DynamicBulletPagination;